export default class AsyncBackend {
    constructor(services, options) {
        this.type = 'backend';
        this.options = null;
        this.init(services, options);
    }
    init(_, options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
    }
    read(lng, ns, callback) {
        const resourceFetcher = this.getResourceFetcher(lng, ns);
        if (resourceFetcher) {
            resourceFetcher()
                .then((res) => callback(null, res.__esModule ? res.default : res))
                .catch((err) => callback(err, false));
        }
        else {
            callback(new Error('resource not found'), false);
        }
    }
    getResourceFetcher(lng, ns) {
        var _a;
        const fetcher = (_a = this.options.resources) === null || _a === void 0 ? void 0 : _a[lng];
        return typeof fetcher === 'function' ? fetcher : fetcher === null || fetcher === void 0 ? void 0 : fetcher[ns];
    }
}
AsyncBackend.type = 'backend';
//# sourceMappingURL=index.js.map